import { takeLatest, put, call } from "redux-saga/effects";
import * as types from "src/types/actions";
import callApi from "./helpers";
import _ from "lodash";
import moment from "moment";
import { apiAuthURI, apiGraphQLURI } from "../env";


const getConfig = (params, query, method = "POST") => {
  let config = {
    mode: "cors",
    headers: {
      Authorization: `Bearer ${params.payload.token}`,
    },
    method: method,
  };

  if (method == "POST") {
    config = {
      ...config,
      headers: {
        ...config.headers,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(query),
    };
  }

  return config;
};

const santiseOptions = (options) => {
  return JSON.stringify(options.map((o) => ({ Code: o.Code, Qty: o.Qty.toString() }))).replace(
    /"([^"]+)":/g,
    "$1:"
  );
};

export function* retrieveReservation(params) {
  const query = {
    query: `{WebRetrieveReservation(
      ResNo: "${params.payload.resNo}"
    ){
      Success
      ReferenceNumber
      WebXGID
      Version
      ResNo
      Status
      Pickup {
        locationCode
        dateTime
      }
      Return {
        locationCode
        dateTime
      }
      Source {
        code
        confirmationNumber
        countryCode
      }
      Vehicle {
        classCode
      }
      Renter {
        customerNumber
        RenterName {
          firstName
          lastName
        }
        Gender
        Title
        Address {
          Street
          City
          PostalCode
          CountryCode
          Email
          StateOrProvCode
          HomeTelephoneNumber
          CellTelephoneNumber
        }
        BirthDate
        PlaceOfBirth
        CountryOfBirth
        DrivingLicence {
          Number
          Issuer
          ExpiryDate
        }
      }
      QuotedRate {
        classCode
        corporateRateID
      }
      ReservationMainNote
      LocalPhone
      Options {
        Code
        Qty
      }
      Messages {
        number
        type
        Text
      }
    }}`,
  };
  try {
    yield call(
      callApi,
      () => fetch(apiGraphQLURI, getConfig(params, query)),
      types.RETRIEVERESERVATION
    );
  } catch (error) {
    yield put({ type: types.RETRIEVERESERVATION_FAILURE, error: error });
  }
}

export function* resEstimate(params) {
  let query = {};

  if (_.has(params, "payload.resno")) {
    query = {
      query: `{
          WebResEstimate(
          ResNo: "${params.payload.resno}"
        ){
          Success
          ReferenceNumber
          WebXGID
          Version
          Total
          CurrencyCode
          IncludedDistance
          RenterCharges {
            code
            desc
            quantity
            total
          }
          Messages {
            number
            type
            Text
          }
        }
      }`,
    };
  } else {
    query = {
      query: `{
        WebResEstimate(
          Pickup: {
            Location: "${params.payload.Reservation.Pickup.locationCode}",
            DateTime: "${params.payload.Reservation.Pickup.dateTime}",
          },
          Return: {
            Location: "${params.payload.Reservation.Return.locationCode}",
            DateTime: "${params.payload.Reservation.Return.dateTime}",
          },
          Renter: {
            FirstName: "${params.payload.Renter.RenterName.firstName}",
            LastName: "${params.payload.Renter.RenterName.lastName}",
            Title: "${params.payload.Reservation.Renter.Title}",
            Gender: "${params.payload.Reservation.Renter.Gender}",
            BirthDate: "${moment(params.payload.Renter.BirthDate, "YYYYMMDD").format(
              "YYYY-MM-DD"
            )}",
            PlaceOfBirth: "${params.payload.Reservation.Renter.PlaceOfBirth}",
            CountryOfBirth: "",
            Address: {
              Street: "${
                _.isArray(params.payload.Renter.Address.Street)
                  ? params.payload.Renter.Address.Street.join(" ").trim()
                  : params.payload.Renter.Address.Street.trim()
              }",
              City: "${params.payload.Renter.Address.City}",
              PostalCode: "${params.payload.Renter.Address.PostalCode}",
              CountryCode: "${params.payload.Renter.Address.StateOrProvCode}",
              Email:" ${params.payload.Renter.Address.Email}",
              StateOrProvCode: "${params.payload.Renter.Address.StateOrProvCode}",
              CellTelephoneNumber: "${params.payload.Renter.Address.CellTelephoneNumber}",
            },
            DrivingLicence: {
              Number: "${_.get(params,'payload.Renter.DrivingLicence.Number','')}",
              Issuer: "${_.get(params,'payload.Renter.DrivingLicence.Issuer','')}",
              ExpiryDate: "${moment(_.get(params,'payload.Renter.DrivingLicence.ExpiryDate',moment()),"YYYYMMDD").format("YYYY-MM-DD")}",
            },
          },
          CountryCode: "${params.payload.Reservation.Source.countryCode}",
          RateID: "${params.payload.RateID}",
          ClassCode: "${params.payload.Reservation.QuotedRate.classCode}",
          CDPID: "${params.payload.Reservation.QuotedRate.corporateRateID}",
          MainNote: "${params.payload.ReservationMainNote}",
          Options: ${santiseOptions(params.payload.Reservation.Options)},
        ){
          Success
          ReferenceNumber
          WebXGID
          Version
          Total
          CurrencyCode
          IncludedDistance
          RenterCharges {
            code
            desc
            quantity
            total
          }
          Messages {
            number
            type
            Text
          }
        }
      }`,
    };
  }

  try {
    yield call(
      callApi,
      () => fetch(apiGraphQLURI, getConfig(params, query)),
      types.RESESTIMATE
    );
  } catch (error) {
    yield put({ type: types.RESESTIMATE_FAILURE, error: error });
  }
}

export function* resOptions(params) {
  const query = {
    query: `{
        WebResOptions(
        ResNo: "${params.payload.resno}"
      ){
        Success
        ReferenceNumber
        WebXGID
        Version
        Options {
          code
          desc
          liability
          maximum_days
          rate
          week_rate
          xday_rate
          rate_type
          available
        }
        Messages {
          number
          type
          Text
        }
      }
    }`,
  };
  try {
    yield call(
      callApi,
      () => fetch(apiGraphQLURI, getConfig(params, query)),
      types.RESOPTIONS
    );
  } catch (error) {
    yield put({ type: types.RESOPTIONS_FAILURE, error: error });
  }
}

export function* getDetails(params) {
  const query = {
    query: `{
      Vehicle: GetVehicleModels(code: "${params.payload.reservation.Vehicle.classCode}"){
        code
        acriss
        title
        image
      },
      Pickup: GetBrandLocations(locationCode:"${params.payload.reservation.Pickup.locationCode}"){
        locationCode
        locationName
        country
        address1
        address2
        address3
        state
        city
        postCode
      },
      Return: GetBrandLocations(locationCode:"${params.payload.reservation.Return.locationCode}"){
        locationCode
        locationName
        country
      },
      WebRates: WebResRates(
        Pickup: {
          Location: "${params.payload.reservation.Pickup.locationCode}",
          DateTime: "${params.payload.reservation.Pickup.dateTime}",
        },
        Return: {
          Location: "${params.payload.reservation.Return.locationCode}",
          DateTime: "${params.payload.reservation.Return.dateTime}",
        },
        Renter: {
          BirthDate: "${params.payload.reservation.Renter.BirthDate}"
        },
        CorpRateID: "${params.payload.reservation.QuotedRate.corporateRateID}",
        ClassGroup: "${params.payload.reservation.QuotedRate.classCode}"
      ){
        Success
        ReferenceNumber
        WebXGID
        Version
        Count
        Messages {
          number
          type
          Text
        }
        Rates {
          RateID
          Class
          Availability
          CurrencyCode
          Estimate
          RateOnlyEstimate
          DropCharge {
            value
            responsibility
          }
          Distance {
            Included
          }
          Liability
          PrePaid
        }
      }
    }`,
  };
  try {
    yield call(
      callApi,
      () => fetch(apiGraphQLURI, getConfig(params, query)),
      types.GETDETAILS
    );
  } catch (error) {
    yield put({ type: types.GETDETAILS_FAILURE, error: error });
  }
}

export function* updateReservation(params) {
  const query = {
    query: `mutation {
      WebUpdateReservation(
        ResNo: "${params.payload.resno}",
        ConfNo: "${params.payload.Reservation.Source.confirmationNumber}",
        Pickup: {
          Location: "${params.payload.Reservation.Pickup.locationCode}",
          DateTime: "${params.payload.Reservation.Pickup.dateTime}",
        },
        Return: {
          Location: "${params.payload.Reservation.Return.locationCode}",
          DateTime: "${params.payload.Reservation.Return.dateTime}",
        },
        Renter: {
          FirstName: "${params.payload.Renter.RenterName.firstName}",
          LastName: "${params.payload.Renter.RenterName.lastName}",
          Title: "${params.payload.Reservation.Renter.Title}",
          Gender: "${params.payload.Reservation.Renter.Gender}",
          BirthDate: "${moment(params.payload.Renter.BirthDate, "YYYYMMDD").format("YYYY-MM-DD")}",
          PlaceOfBirth: "${params.payload.Reservation.Renter.PlaceOfBirth}",
          CountryOfBirth: "",
          Address: {
            Street: "${
              _.isArray(params.payload.Renter.Address.Street)
                ? params.payload.Renter.Address.Street.join(" ").trim()
                : params.payload.Renter.Address.Street.trim()
            }",
            City: "${params.payload.Renter.Address.City}",
            PostalCode: "${params.payload.Renter.Address.PostalCode}",
            CountryCode: "${params.payload.Renter.Address.StateOrProvCode}",
            Email:" ${params.payload.Renter.Address.Email}",
            StateOrProvCode: "${params.payload.Renter.Address.StateOrProvCode}",
            CellTelephoneNumber: "${params.payload.Renter.Address.CellTelephoneNumber}",
          },
          DrivingLicence: {
            Number: "${params.payload.Renter.DrivingLicence.Number}",
            Issuer: "${params.payload.Renter.DrivingLicence.Issuer}",
            ExpiryDate: "${moment(
              params.payload.Renter.DrivingLicence.ExpiryDate,
              "YYYYMMDD"
            ).format("YYYY-MM-DD")}",
          },
        },
        CountryCode: "${params.payload.Reservation.Source.countryCode}",
        RateID: "${params.payload.RateID}",
        ClassCode: "${params.payload.Reservation.QuotedRate.classCode}",
        CDPID: "${params.payload.Reservation.QuotedRate.corporateRateID}",
        MainNote: "${params.payload.ReservationMainNote}",
        Options: ${santiseOptions(params.payload.Reservation.Options)}
      ){
        Success
        ReferenceNumber
        WebXGID
        Version
        Messages {
          number
          type
          Text
        }
      }
    }`,
  };

  try {
    yield call(
      callApi,
      () => fetch(apiGraphQLURI, getConfig(params, query)),
      types.UPDATERESERVATION
    );
  } catch (error) {
    yield put({ type: types.UPDATERESERVATION_FAILURE, error: error });
  }
}

export function* watchReservationRequest() {
  yield takeLatest(types.RETRIEVERESERVATION, retrieveReservation);
  yield takeLatest(types.RESESTIMATE, resEstimate);
  yield takeLatest(types.RESOPTIONS, resOptions);
  yield takeLatest(types.UPDATERESERVATION, updateReservation);
  yield takeLatest(types.GETDETAILS, getDetails);
}
